import { useMutation } from '@tanstack/react-query';
import service from '../service';
import type { ConfirmPaymentIntentResponse } from '@Types/toast';

export type ConfirmPaymentIntentVariables = {
  restaurantGuid: string;
  paymentIntentId: string;
  sessionSecret: string;
  cardId: string;
};

export type UseConfirmPaymentIntentOptions = {
  onSuccess?: (data: ConfirmPaymentIntentResponse) => void;
  onError?: (error: Error) => void;
};

export function useConfirmPaymentIntent(
  options: UseConfirmPaymentIntentOptions = {},
) {
  return useMutation({
    mutationKey: ['paymentIntent', 'confirm'],
    mutationFn: async (vars: ConfirmPaymentIntentVariables) => {
      const { restaurantGuid, paymentIntentId, sessionSecret, cardId } = vars;

      if (!restaurantGuid || !paymentIntentId || !sessionSecret || !cardId) {
        throw new Error(
          'Missing required fields: restaurantGuid, paymentIntentId, sessionSecret, cardId',
        );
      }

      const cardDetails = {
        paymentMethodId: cardId,
        sessionSecret,
        paymentMethodData: {
          scope: 'SINGLE_USE' as const,
          type: 'SAVED_CARD' as const,
        },
      };

      const res = await service.confirmPaymentIntent(
        paymentIntentId,
        cardDetails,
        restaurantGuid,
      );

      if (!res) {
        throw new Error('Failed to confirm payment intent');
      }

      return res;
    },
    retry: 0,
    ...options,
  });
}
